import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.teensCheckbox = this.element.querySelector("#teens_field")
    this.adultsCheckbox = this.element.querySelector("#adults_field")
    this.adminsCheckbox = this.element.querySelector("#admin_only_field")
    this.driveTestIncludedCheckbox = this.element.querySelector("#drive_test_included_field")
    this.preTestDurationSection = this.element.querySelector("#pre-test-duration-section")
    this.studentProgramCheckboxes = [
      ...this.element.querySelectorAll('input[type="checkbox"]'),
    ].filter((checkbox) =>
      /^driving_schools_package\[student_program_id_\d+\]$/.test(checkbox.name)
    )

    this.boundTeensOrAdults = this.teensOrAdultsChanged.bind(this)
    this.boundAdmins = this.adminsChanged.bind(this)
    this.boundStudentProgramChanged = this.studentProgramChanged.bind(this)
    this.boundDriveTestIncludedChanged = this.driveTestIncludedChanged.bind(this)

    if (this.teensCheckbox) {
      this.teensCheckbox.addEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adultsCheckbox) {
      this.adultsCheckbox.addEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adminsCheckbox) {
      this.adminsCheckbox.addEventListener("change", this.boundAdmins)
    }
    if (this.driveTestIncludedCheckbox) {
      this.driveTestIncludedCheckbox.addEventListener("change", this.boundDriveTestIncludedChanged)
    }
    this.studentProgramCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.boundStudentProgramChanged)
    })

    this.togglePreTestDurationSection()
  }

  disconnect() {
    if (this.teensCheckbox) {
      this.teensCheckbox.removeEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adultsCheckbox) {
      this.adultsCheckbox.removeEventListener("change", this.boundTeensOrAdults)
    }
    if (this.adminsCheckbox) {
      this.adminsCheckbox.removeEventListener("change", this.boundAdmins)
    }
    if (this.driveTestIncludedCheckbox) {
      this.driveTestIncludedCheckbox.removeEventListener("change", this.boundDriveTestIncludedChanged)
    }
    this.studentProgramCheckboxes.forEach((checkbox) => {
      checkbox.removeEventListener("change", this.boundStudentProgramChanged)
    })
  }

  teensOrAdultsChanged(event) {
    if (event.target.checked && this.adminsCheckbox) {
      this.adminsCheckbox.checked = false
    }
  }

  adminsChanged(event) {
    if (event.target.checked) {
      if (this.teensCheckbox) {
        this.teensCheckbox.checked = false
      }
      if (this.adultsCheckbox) {
        this.adultsCheckbox.checked = false
      }
      this.studentProgramCheckboxes.forEach((checkbox) => {
        checkbox.checked = false
      })
    }
  }

  studentProgramChanged(event) {
    if (event.target.checked && this.adminsCheckbox) {
      this.adminsCheckbox.checked = false
    }
  }

  driveTestIncludedChanged() {
    this.togglePreTestDurationSection()
  }

  togglePreTestDurationSection() {
    if (!this.preTestDurationSection) return

    const shouldShow = this.driveTestIncludedCheckbox?.checked === true
    this.preTestDurationSection.classList.toggle("u-hidden", !shouldShow)
  }
}
